/* lua.js generated code undefined */
require("clover/animation/config/ParticleAnimationConfig")
ParticleAnimation = xClass("ParticleAnimation")
let _instance = null
let calculateHelper = table(
    [0, table(1, 1)],
    [0, table([0, -1], 1)],
    [0, table([0, -1], [0, -1])],
    [0, table(1, [0, -1])]
)
//-------------------------------------------------------------------------------------------------
//begin v2
//-------------------------------------------------------------------------------------------------
ParticleAnimation.getInstance = function () {
    if (!_instance) {
        _instance = ParticleAnimation.new()
    }
    return _instance
}
//-------------------------------------------------------------------------------------------------
ParticleAnimation.prototype.ctor = function () {
}
//-------------------------------------------------------------------------------------------------
ParticleAnimation.prototype.startLevel = function(){
    let self = this
	if (self.rootNode != null){
		self.particleList = []
		self.rootNode = null
    }

	if (GameBoardLogic != null 
        && GameBoardLogic.instance != null
        && GameBoardLogic.instance.boardView != null
    ) {
		self.rootNode = cc.Node.create()
		let sceneNode = GameBoardLogic.instance.boardView.getShowPanel(ItemSpriteType.kSnowEffect)
		sceneNode.addChild(self.rootNode)

		self.particleList = []
    }
}
//-------------------------------------------------------------------------------------------------
//抽取涵姐接口创建粒子
ParticleAnimation.prototype.createInternal = function(
	imageName,posx,posy,shadowOpacity,
	rotationSpeed,scale,speed,angle,delayTime,
	gravity,shadowOffset,particleParent
){
    let self = this
	var particle = cc.Sprite.createWithSpriteFrameName(imageName)
	var shadow = cc.Sprite.createWithSpriteFrameName(imageName)
	if ((particle == null) || (shadow == null)) {
		return
    }
	particle.setPosition(cc.p(posx,posy))
	shadow.setPosition(particle.getPosition())
	shadow.setColor(cc.c3b(0, 0, 0)) 
	shadow.setOpacity(shadowOpacity) 
	particle.setScale(scale)
	shadow.setScale(scale)

	// 设置发射速度
	particle.launchSpeed = cc.p(speed * Math.cos(angle * Math.PI / 180), speed * Math.sin(angle * Math.PI / 180))
	particle.life = math.random(3, 4)
	particle.runningTime = 0
	particle.delayTime = delayTime
	particle.rotationSpeed = rotationSpeed
	particle.cfgGravity = gravity
	particle.shadowOffset = shadowOffset

    //console.warn("[ParticleAnimation] speed="+speed+" angle="+angle)

	//交给particlaAnimation托管的会丢进列表（对局内）
	if (particleParent == null) {
		//table.insert(self.particleList, {p:particle,s:shadow,lifeEnd:false})
        self.particleList.push({p:particle,s:shadow,lifeEnd:false})
		self.rootNode.addChild(shadow)
		self.rootNode.addChild(particle)
    }
	else{
        function update(dt){
			self.updateInternal({p:particle,s:shadow,lifeEnd:false,autoRemove:true},dt)
        }
		particleParent.addChild(shadow)
		particleParent.addChild(particle)
        particle.onUpdate(update)
    }

	return [particle,shadow]
}
//-------------------------------------------------------------------------------------------------
ParticleAnimation.prototype.update = function(dt){
    let self = this
	for (k=self.particleList.length - 1; k >= 0; k--) {
		self.updateInternal(self.particleList[k],dt)
    }

	for (k=self.particleList.length - 1; k >= 0; k--) {
		if (self.particleList[k].lifeEnd){
			self.particleList[k].p.removeFromParent()
			self.particleList[k].p = null
			self.particleList[k].s.removeFromParent()
			self.particleList[k].s = null
			self.particleList.splice(k,1)
        }
    }
}
//-------------------------------------------------------------------------------------------------
ParticleAnimation.prototype.updateInternal = function(pInfo,dt){
    let self = this
	if (pInfo.lifeEnd) {
		return
    }
	if (dt == null) {
		console.warn("dt is null")
		dt = 0.0333
    }

	let particle = pInfo.p
	let shadow = pInfo.s
	if (particle.runningTime < particle.delayTime) {
		particle.gravity = cc.p(0, 0) 
    }else{
		particle.gravity = cc.p(0, particle.cfgGravity) 
	}

	let currentPos = cc.p(particle.getPosition())
    //console.warn("[ParticleAnimation] updateInternal currentPos="+currentPos.x+","+currentPos.y)
	let newPos = cc.p(currentPos.x + particle.launchSpeed.x * dt, currentPos.y + particle.launchSpeed.y * dt)
    //console.warn("[ParticleAnimation] updateInternal newPos1="+newPos.x+","+newPos.y)
    //console.warn("[ParticleAnimation] updateInternal launchSpeed="+particle.launchSpeed.x+","+particle.launchSpeed.y)
	newPos = cc.p(newPos.x + particle.gravity.x * 0.5 * dt * dt, newPos.y + particle.gravity.y * 0.5 * dt * dt) // 使用基础物理公式s = ut + 0.5at^2模拟重力
	particle.setPosition(newPos)
    //console.warn("[ParticleAnimation] updateInternal newPos2="+newPos.x+","+newPos.y)

	shadow.setPosition(newPos.x, newPos.y - particle.shadowOffset)

	particle.launchSpeed = cc.p(particle.launchSpeed.x + particle.gravity.x * dt, particle.launchSpeed.y + particle.gravity.y * dt) // 使用基础物理公式v = u + at模拟速度变化

	let rotation =  particle.getRotation() + (particle.launchSpeed.x > 0 && 1 || -1) * dt * particle.rotationSpeed
	particle.setRotation(rotation)
	shadow.setRotation(rotation)

	particle.runningTime = particle.runningTime + dt
	// 判断node是否超过存在时间
	if (particle.runningTime >= particle.life) {
		pInfo.lifeEnd = true
		//非托管 直接删除 添加非空判断 外面的父节点有可能被提前remove
		if (pInfo.autoRemove && (particle != null) && (shadow != null)){
            particle.unscheduleUpdate()
            particle.removeFromParent()
            shadow.removeFromParent()
        }
    }
}
//-------------------------------------------------------------------------------------------------
//num为0时，从plists里依次取每个碎片
ParticleAnimation.prototype.createParticleBombAnimation = function(
	plists, num, speedmin, speedmax, scalemin, 
	scalemax, delayTime, rotationSpeedmin, rotationSpeedmax, gravity,
	shadowOpacity, shadowOffset, evenly ,parentPos,particleParent
){
    let self = this
	gravity = gravity * -1
    let imgCount = (num === 0 && $len(plists) || num)
    for (let i = 1; i <= imgCount; i += 1) {
        let imageName = plists[num === 0 && i || math.random($len(plists))]
		let particle = cc.Sprite.createWithSpriteFrameName(imageName)
		let shadow = cc.Sprite.createWithSpriteFrameName(imageName)
		if (particle!=null && shadow!=null) {
			let pos = cc.p(parentPos.x,  parentPos.y)
			//均匀随机分布
			if (evenly && evenly.square) {
				pos = cc.p(math.random(0, evenly.square / 2), math.random(0, evenly.square / 2))
				pos.x = pos.x * calculateHelper[i % 4 + 1][1] + parentPos.x
				pos.y = pos.y * calculateHelper[i % 4 + 1][2] + parentPos.y
            }
	
			let rotationSpeed = math.random(rotationSpeedmin, rotationSpeedmax)
			let scale = scalemin + math.random() * (scalemax - scalemin)  
			//设置发射速度
			let speed = math.random(speedmin, speedmax)  
			let angle = math.random(90 * i, 90 * i + 90)
	
			self.createInternal(
				imageName,pos.x,pos.y,shadowOpacity,
				rotationSpeed,scale,speed,angle,delayTime,
				gravity,shadowOffset,particleParent
			)
		}
    }
}
//-------------------------------------------------------------------------------------------------
ParticleAnimation.prototype.createFixPosParticleBombAnimation = function(
	plists, fixPos, angles, speedmin, speedmax, 
	delayTime, rotationSpeedmin, rotationSpeedmax, gravity, 
	shadowOpacity, shadowOffset, scalemin,scalemax,parentPos,particleParent
){
    let self = this
	gravity = gravity * -1
    let num = $len(plists)
    for (let i = 1; i <= num; i += 1) {
		let imageName = plists[i]
		let particle = cc.Sprite.createWithSpriteFrameName(imageName)
		let shadow = cc.Sprite.createWithSpriteFrameName(imageName)
		if (particle!=null && shadow!=null){
			let scale = 1
			if (scalemin!=null && scalemax!=null){
                scale = scalemin + math.random() * (scalemax - scalemin)  
            }
			
			let rotationSpeed = math.random(rotationSpeedmin, rotationSpeedmax)
			// 设置发射速度
			let speed = math.random(speedmin, speedmax) 
			let angle = math.random(angles[i].x, angles[i].y)
	
			self.createInternal(
				imageName,fixPos[i].x + parentPos.x,fixPos[i].y + parentPos.y,shadowOpacity,
				rotationSpeed,scale,speed,angle,delayTime,gravity,
				shadowOffset,particleParent
			)
		}
    }
}
//-------------------------------------------------------------------------------------------------
// 播放碎片动画 
/*
	flakeConfigList:碎片配置
	level:目标层级
	flakePosX|flakePosY:外部坐标
	plist:图集 可为空
	particleParent:有值就使用该值做父节点
*/
ParticleAnimation.prototype.playDecFlake = function(
	flakeConfigList,level,flakePosX,flakePosY,
	plist,particleParent
	){
        let self = this
        let speed = GameSpeedManager.getInstance().getSpeedUpShift()
        let flakeconfig = flakeConfigList[speed] || flakeConfigList[1]
        if (flakeconfig[level] == null) {
            return
        }
        if (plist!=null) {
            FrameLoader.loadImageWithPlist(plist)
        }
    
        //外部节点 坐标叠加到粒子上未必对 跟外部节点本身有关，设置好位置后清0
        if (particleParent != null){
            particleParent.setPosition(flakePosX,flakePosY)
            flakePosX = 0
            flakePosY = 0
        }
        
        let fixconfig = flakeconfig[level]["fix"]
        if (fixconfig) {
            self.createFixPosParticleBombAnimation(
                fixconfig["plists"], fixconfig["pos"], fixconfig["angle"], 
                fixconfig["other"][1],  fixconfig["other"][2], fixconfig["other"][3], 
                fixconfig["other"][4], fixconfig["other"][5], fixconfig["other"][6], 
                fixconfig["other"][7], fixconfig["other"][8],fixconfig["other"][9],
                fixconfig["other"][10],cc.p(flakePosX,flakePosY),particleParent
            )
        }
    
        let randomconfig = flakeconfig[level]["random"]
        if (randomconfig != null) {
            self.createParticleBombAnimation(
                randomconfig["plists"],  randomconfig["other"][1],  randomconfig["other"][2], 
                randomconfig["other"][3], randomconfig["other"][4], randomconfig["other"][5], 
                randomconfig["other"][6], randomconfig["other"][7], randomconfig["other"][8], 
                randomconfig["other"][9], randomconfig["other"][10], randomconfig["other"][11], 
                randomconfig["other"][12],cc.p(flakePosX,flakePosY),particleParent
            )
        }
}
//-------------------------------------------------------------------------------------------------
//end v2
//-------------------------------------------------------------------------------------------------
